// extracted by mini-css-extract-plugin
module.exports =  {"emptyStarredWrapper":"EmptyStarred-module__emptyStarredWrapper--dpOlq","title":"EmptyStarred-module__title--czH03","description":"EmptyStarred-module__description--YN1Q4"};